import { List } from 'foundations-components/transitional/components/List';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTracker from '../../../utils/UsageTracker';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AllContentTypesFilter = ({
  appearsIn
}) => {
  const [contentTypes, setContentTypes] = useSearchParam(FILTER_TYPES.CONTENT_TYPE);
  const handleAllContentTypesChange = (value, checked) => {
    let selectedTypes = [];
    if (checked) {
      selectedTypes = [...contentTypes, value];
    } else {
      selectedTypes = contentTypes.filter(type => type !== value);
    }
    UsageTracker.trackStandalone('Filter Interaction', {
      action: checked ? 'filter-selected' : 'filter-deselected',
      value: selectedTypes,
      isDropdown: true,
      key: 'all-content-types-filter',
      appearsIn
    });
    setContentTypes(selectedTypes);
  };
  const handleClearAllContentTypesFilter = () => {
    UsageTracker.trackStandalone('Filter Interaction', {
      action: 'filter-deselected',
      isDropdown: true,
      key: 'all-content-types-filter',
      appearsIn
    });
    setContentTypes([]);
  };
  return /*#__PURE__*/_jsx(View, {
    children: /*#__PURE__*/_jsx(Dropdown, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.topFilters.contentType.filterTitle"
      }),
      children: /*#__PURE__*/_jsxs(List, {
        children: [/*#__PURE__*/_jsx(Checkbox, {
          checked: !contentTypes.length,
          onChange: handleClearAllContentTypesFilter,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.topFilters.contentType.filterReset"
          })
        }), /*#__PURE__*/_jsx(Checkbox, {
          checked: contentTypes.includes('LEARNING_PATH'),
          onChange: evt => handleAllContentTypesChange('LEARNING_PATH', evt.target.checked),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.topFilters.contentType.LEARNING_PATH"
          })
        }), /*#__PURE__*/_jsx(Checkbox, {
          checked: contentTypes.includes('COURSE'),
          onChange: evt => handleAllContentTypesChange('COURSE', evt.target.checked),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.topFilters.contentType.COURSE"
          })
        }), /*#__PURE__*/_jsx(Checkbox, {
          checked: contentTypes.includes('LESSON'),
          onChange: evt => handleAllContentTypesChange('LESSON', evt.target.checked),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.topFilters.contentType.LESSON"
          })
        }), /*#__PURE__*/_jsx(Checkbox, {
          checked: contentTypes.includes('SHORT_FORM_CONTENT'),
          onChange: evt => handleAllContentTypesChange('SHORT_FORM_CONTENT', evt.target.checked),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.topFilters.contentType.SHORT_FORM_CONTENT"
          })
        }), /*#__PURE__*/_jsx(Checkbox, {
          checked: contentTypes.includes('TEMPLATE'),
          onChange: evt => handleAllContentTypesChange('TEMPLATE', evt.target.checked),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.topFilters.contentType.TEMPLATE"
          })
        }), /*#__PURE__*/_jsx(Checkbox, {
          checked: contentTypes.includes('EBOOK'),
          onChange: evt => handleAllContentTypesChange('EBOOK', evt.target.checked),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.topFilters.contentType.EBOOK"
          })
        })]
      })
    })
  });
};